import { Validator } from '@vista-digital/validator';
import { defaultMemberPaymentCardWalletAssets, memberPaymentCardWalletAssetsValidator } from './assets';
import { defaultMemberPaymentCardWalletConfig, memberPaymentCardWalletConfigValidator } from './config';
import { defaultMemberPaymentCardWalletDisplayText, memberPaymentCardWalletDisplayTextValidator } from './display-text';
import { memberPaymentCardWalletEventsValidator } from './events';
export const memberPaymentCardWalletPropsValidator = Validator.object({
    paymentMethodId: Validator.number({ min: 1 }),
    config: memberPaymentCardWalletConfigValidator,
    displayText: memberPaymentCardWalletDisplayTextValidator,
    assets: memberPaymentCardWalletAssetsValidator,
    events: memberPaymentCardWalletEventsValidator
});
export const defaultMemberPaymentCardWalletProps = {
    paymentMethodId: undefined,
    config: defaultMemberPaymentCardWalletConfig,
    displayText: defaultMemberPaymentCardWalletDisplayText,
    assets: defaultMemberPaymentCardWalletAssets,
    events: {}
};
